import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { FlexCenterWrapper } from 'wrappers';
import { NavigationButton, PageNumber } from './atoms';
import internalState from './internalState';
import { LeftArrowSvg, RightArrowSvg } from 'components/icons';

export const definition = {
  name: 'PageSelector',
  controller: Controller,
  initialProps: ({ pageNumber, pageSize, total }) => ({ pageNumber, pageSize, total }),
  props: internalState,
  elements: [
    {
      component: NavigationButton,
      name: 'FirstPage',
      displayValue: ({ }) => LeftArrowSvg({ double: true }),
      displayState: ({ pageNumber}) => {
        const isHidden = pageNumber === 0
        return { hidden: isHidden }
      },
      bindings: ({ pageNumber }) => ({ pageNumber })
    },
    {
      component: NavigationButton,
      name: 'PrevPage',
      displayValue: ({ }) => LeftArrowSvg({}),
      displayState: ({ pageNumber}) => {
          const isHidden = pageNumber === 0
          return { hidden: isHidden }
      },
      bindings: ({ pageNumber }) => ({ pageNumber })
    },
    {
      component: PageNumber,
      isListOf: 'navigationPages',
      name: 'PageNumber',
      displayValue: ({ pageNumber, navigationPage }) => {
        return pageNumber + navigationPage + 1;
      },
      displayState: ({ navigationPage, pageNumber, pageSize, total }) => {
        const pagesCount = Math.ceil(total / pageSize);
        const isHidden = (pageNumber + navigationPage < 0) || (pageNumber + navigationPage >= pagesCount);
        return { selected: navigationPage === 0, hidden: isHidden }
      },
      bindings: ({ navigationPage, pageNumber }) => ({ navigationPage, pageNumber })
    },
    {
      component: NavigationButton,
      name: 'NextPage',
      displayValue: ({ }) => RightArrowSvg({}),
      displayState: ({ pageNumber ,total ,pageSize }) => {
            const isHidden = pageNumber+1 === Math.ceil(total / pageSize);
            return { hidden: isHidden }
      },
      bindings: ({ pageNumber, total, pageSize }) => {
        const pagesCount = Math.ceil(total / pageSize);
        return { pageNumber, pagesCount }
      }
    },
    {
      component: NavigationButton,
      name: 'LastPage',
      displayValue: ({ }) => RightArrowSvg({ double: true }),
      displayState: ({ pageNumber ,total ,pageSize }) => {
        const isHidden = pageNumber+1 === Math.ceil(total / pageSize);
        return { hidden: isHidden }
      },
      bindings: ({ pageNumber, pageSize, total }) => {
        const pagesCount = Math.ceil(total / pageSize);
        return { pageNumber, pagesCount }
      }
    },
  ]
};

const PageSelector = wrap(ContainerComponent(definition), FlexCenterWrapper);

export default PageSelector;